__turbopack_context__.v({
  "chevron": "FormFieldEditorial-module__lGwjTa__chevron",
  "chevronSlot": "FormFieldEditorial-module__lGwjTa__chevronSlot",
  "error": "FormFieldEditorial-module__lGwjTa__error",
  "fadeIn": "FormFieldEditorial-module__lGwjTa__fadeIn",
  "field": "FormFieldEditorial-module__lGwjTa__field",
  "hasError": "FormFieldEditorial-module__lGwjTa__hasError",
  "input": "FormFieldEditorial-module__lGwjTa__input",
  "label": "FormFieldEditorial-module__lGwjTa__label",
  "required": "FormFieldEditorial-module__lGwjTa__required",
  "select": "FormFieldEditorial-module__lGwjTa__select",
  "selectWrapper": "FormFieldEditorial-module__lGwjTa__selectWrapper",
  "textarea": "FormFieldEditorial-module__lGwjTa__textarea",
});
